const classTransition = (
  element,
  className,
  { awaitForProperty, awaitForElement: awaitForElementIn, timeout, mode }
) => {
  if (!element) {
    return Promise.reject("No element defined");
  }

  if (!className) {
    return Promise.reject("No class defined");
  }

  const awaitForElement = !awaitForElementIn ? element : awaitForElementIn;

  if (
    (mode === "remove" && !element.classList.contains(className)) ||
    (mode !== "remove" && element.classList.contains(className))
  ) {
    return Promise.resolve(0);
  }

  let timeoutTimer;
  let handleTransitionEnd;
  const timeoutPromise = new Promise(
    (resolve) => (timeoutTimer = setTimeout(resolve, timeout))
  ).then(() => {
    awaitForElement.removeEventListener("transitionend", handleTransitionEnd);
    return timeout;
  });

  const transitionPromise = new Promise((resolve) => {
    handleTransitionEnd = ({ propertyName, elapsedTime, target }) => {
      if (awaitForElement !== target) {
        return;
      }

      if (!awaitForProperty || awaitForProperty === propertyName) {
        clearTimeout(timeoutTimer);
        resolve(elapsedTime);
        awaitForElement.removeEventListener(
          "transitionend",
          handleTransitionEnd
        );
      }
    };

    awaitForElement.addEventListener("transitionend", handleTransitionEnd);

    if (mode === "remove") {
      element.classList.remove(className);
    } else {
      element.classList.add(className);
    }
  });

  return Promise.race([transitionPromise, timeoutPromise]);
};

export const addClassTransition = (
  element,
  className,
  { awaitForProperty, timeout = 3000 }
) => {
  return classTransition(element, className, {
    awaitForProperty,
    timeout,
    mode: "add",
  });
};

export const removeClassTransition = (
  element,
  className,
  { awaitForProperty, timeout = 3000 }
) => {
  return classTransition(element, className, {
    awaitForProperty,
    timeout,
    mode: "remove",
  });
};

export default addClassTransition;
